import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { get, includes, uniqBy, sortBy, keys } from 'lodash';
import { push } from 'connected-react-router';
import compose from 'recompose/compose';
import { Button, Checkbox, FormControlLabel, Link, Tooltip, Typography, withStyles, Grid } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { getI18n } from '../../../utils/intl';
import { useIntl } from 'react-intl';
import { array, arrayOf, bool, func, object, shape, string } from 'prop-types';

import {
  AlertDialog,
  AlertMessages, Footer, FormAutoCompleteCombo, FormSelect, FormTextField, HelpContainer,
  LoadingDialog,
} from '../../../components';
import {
  fetchListDetails,
  fetchRequestDetails,
  submitRequest,
  reviewApplication,
  fetchOrgSuggestions,
  withdrawRequest,
} from '../../../actions/requests';
import {
  getAppReviewUpdateStatus,
  getErrors,
  getDetailsListResults,
  getOrgSuggestions,
  getRequestDetails,
  getRequestUpdateStatus,
  getAppReviewResponse,
  getAppWithdrawStatus,
  getOperationLoading,
} from '../../../reducers/request';
import { getFeatureFlagApiPlans } from '../../../reducers/portalConfig';
import styles from './styles';
import { RequestSectionTable, MultiRequestTable } from './SectionTable';
import moment from 'moment';
import {
  buildDetailsData, buildEditRequestTable, buildEditApisRequestTable,
  buildRegistrationRequestTable, buildSingleApplicationRequestMap, getTableColumns,
  getMultiRequestTableColumns, buildCertificatesData, buildEditProductsRequestTable,
} from './utils';
import { ALERT_SUCCESS, SUCCESS, ALERT_ERROR, FAIL, getOrgBoundRoles } from '../../../constants';
import { APPLICATION_REQUEST_FAILED_MORE_INFO } from '../../Application/AppDetails/labels'
import {
  hasAdminRole, hasDeveloperRole, hasPublisherRole,
  hasOrgPublisherRole, hasApiOwnerRole,
} from '../../../utils';
import { getUserDetails } from '../../../reducers/portalConfig';
import { bumpRequestsNumberVersion } from '../utils';

export const ApplicationRequestDetails = (props) => {
  const {
    classes,
    listResults,
    requestDetails,
    requestUpdateStatus,
    appReviewUpdateStatus,
    orgSuggestions,
    errors,
    fetchOrgSuggestions,
    apiPlansEnabled,
    appReviewResponse,
    appWithdrawStatus,
    operationLoading,
  } = props;

  const orderList = ["registration", "status", "addinfo", "details", "drydetails",
    "customfields", "apis", "apiplans", "apigroups", "products", "apikeys", "certificates", "oauthclients"];
  const [notificationMessage, setNotificationMessage] = useState(localStorage.getItem('notificationMessage'));
  const [notificationStatus, setNotificationStatus] = useState(localStorage.getItem('notificationStatus'));
  const [requestDetailsMap, setRequestDetailsMap] = useState({});
  const [orgName, setOrgName] = useState('');
  const [requestDate, setRequestDate] = useState('');
  const [requestor, setRequestor] = useState('');
  const [requestType, setRequestType] = useState('');
  const [reviewRequestType, setReviewRequestType] = useState('');
  const [apisRequestDetails, setApisRequestDetails] = useState([]);
  const [productsRequestDetails, setProductsRequestDetails] = useState([]);
  const [requestDetailsCount, setRequestDetailsCount] = useState(0);
  const [entityName, setEntityName] = useState('');
  const [showChangesOnly, setShowChangesOnly] = useState(false);
  const [requestInfoMap, setRequestInfoMap] = useState({});
  const [singleRequest, setSingleRequest] = useState(false);
  const [showActionAlert, setShowActionAlert] = useState(false);
  const [showActionAlertMoreInfo, setShowActionAlertMoreInfo] = useState(false);
  const [actionType, setActionType] = useState('');
  const [uuidType, setUuidType] = useState('');
  const [actionUuid, setActionUuid] = useState('');
  const [actionTable, setActionTable] = useState('');
  const [pendingRequestCount, setPendingRequestCount] = useState(-1);
  const [actionTableMap, setActionTableMap] = useState({});
  const [alertReason, setAlertReason] = useState('');
  const [detailsRequestExist, setDetailsRequestExist] = useState(true);
  const [singleRequestUuid, setSingleRequestUuid] = useState('');
  const intl = getI18n(useIntl());
  const [shouldAssignOrgRole, setShouldAssignOrgRole] = useState(false);
  const [assignedOrg, setAssignedOrg] = useState({ uuid: '', name: '' });
  const [assignedOrgSearchText, setAssignedOrgSearchText] = useState('');
  const assignRoleOptions = getOrgBoundRoles(intl);
  const [assignedRole, setAssignedRole] = useState(assignRoleOptions[0].uuid);
  const [userEmail, setUserEmail] = useState('');
  const [userEmailError, setUserEmailError] = useState(false);
  const [shouldNotifyUser, setShouldNotifyUser] = useState(false);
  const [disableActionSubmit, setDisableActionSubmit] = useState(false);
  const isAdmin = hasAdminRole(props.user);
  const isPublisherRole = hasPublisherRole(props.user);
  const isOrgPublisherRole = hasOrgPublisherRole(props.user);
  const isApiOwnerRole = hasApiOwnerRole(props.user);
  const { getI18nMessage } = intl;
  const entityUuid = get(props, 'match.path') &&
    get(props, 'match.path').includes('/details/') &&
    get(props, 'match.params.entityUuid');

  const [showOAuthClientDetails, setShowOAuthClientDetails] = useState(null);

  const getRequestTypeHeading = requestType => {
    if (!requestType) {
      return ''
    }
    switch (requestType) {
      case 'APPLICATION':
        return intl.getI18nMessage('label.request.details.request.type.heading.application');
      case 'APPLICATION_DELETE':
        return (<span className={classes.deleteHeading}> {intl.getI18nMessage('label.request.details.request.type.heading.application.delete')}</span>);
      case 'REGISTRATION':
        return intl.getI18nMessage('label.request.details.request.type.heading.registration');
    }
    return (<div className={classes.descriptionField}>
      {intl.getI18nMessage('label.request.details.request.type.heading.application.edit')}
      <Tooltip
        title={intl.getI18nMessage('label.request.details.edit.request.tooltip')}
        arrow placement="right">
        <HelpIcon className={classes.helpIconEdit} />
      </Tooltip>
    </div>);
  }
  const getUserName = () => hasAdminRole(props.user) ?
    (<Link href={`/admin/console/users/details/${requestor.uuid}`}>
      {requestor.name}
    </Link>) :
    (<span>
      {requestor.name}
    </span>);
  const getOrgName = () => hasPublisherRole(props.user) ?
    (<Link href={`/admin/console/organizations/details/${orgName.uuid}`}>
      {orgName.name}
    </Link>) :
    (<span>{orgName.name}</span>);
  const getSubTitleContent = () => {
    if (requestType === 'REGISTRATION') {
      return `${intl.getI18nMessage("label.request.details.requestdate.sub.title")}: ${requestDate}`;
    }
    const subTitle = (<span>{intl.getI18nMessage('label.request.details.organization.sub.title')}
      {getOrgName()}
    </span>);
    if (requestDate) {
      return (<div>{subTitle} • {intl.getI18nMessage('label.request.details.requestdate.sub.title')}: {requestDate} •
        {intl.getI18nMessage('label.request.details.requestor.sub.title')}
        {getUserName()} </div>)
    }
    return subTitle;
  }
  useEffect(() => {
    if (hasDeveloperRole(props.user)) {
      props.push('/404');
    }
    props.fetchListDetails({ entityUuid });
    notifyMessages('', '');
    fetchOrgSuggestions({ name: '', status: "ENABLED" });
  }, []);
  useEffect(() => {
    if (listResults) {
      if (listResults.length > 0) {
        const firstRequest = listResults[0];
        const reqType = get(firstRequest, 'requestType');
        const reqSubtype = get(firstRequest, 'requestSubtype');
        if (reqType === 'APPLICATION' || reqType === 'REGISTRATION' ||
          (reqType === 'APPLICATION_DETAILS' && reqSubtype === 'APP_STATUS_CHANGE')) {
          setSingleRequest(true);
          setRequestDate(moment(firstRequest.modifyTs).format('ddd, MMM DD, YYYY HH:mm:ss ([GMT]Z)'));
          if (reqType === 'REGISTRATION') {
            setRequestDetailsMap({
              ['registration']: buildRegistrationRequestTable(firstRequest),
            });
            setUserEmail(firstRequest.entityName);
          }
          setRequestType(reqSubtype === 'DELETE' || reqSubtype === 'UPDATE' ? `APPLICATION_${reqSubtype}` : reqType);
          setSingleRequestUuid(firstRequest.uuid);
        } else {
          setDetailsRequestExist(listResults.find(req => req.requestType === 'APPLICATION_DETAILS'));
          setRequestType('APPLICATION_EDIT');
        }
        setEntityName(firstRequest.entityName);
        setOrgName({
          name: firstRequest.organizationName,
          uuid: firstRequest.organizationUuid,
        });
        setPendingRequestCount(listResults.length);
        if (reqType !== 'REGISTRATION') {
          listResults.map(req => props.fetchRequestDetails(req.uuid));
        }
      }
    }
  }, [listResults]);
  useEffect(() => {
    if (requestDetails && requestDetails.request) {
      setRequestDetailsCount(requestDetailsCount + 1);
      const reqType = requestDetails.request.requestType;
      if (singleRequest) {
        setRequestor({
          name: requestDetails.request.modifiedBy,
          uuid: requestDetails.request.userUuid,
        });
      }
      if (reqType === 'APPLICATION') {
        setRequestDetailsMap(buildSingleApplicationRequestMap(classes, requestDetails));
      } else {
        //Added for apis and apisPlans
        if (reqType === "PATCH_APPLICATION_API_PLANS" || reqType === "PATCH_APPLICATION_APIS") {
          const obj = apisRequestDetails;
          obj.push(requestDetails);
          setApisRequestDetails(obj);
        } else if (reqType === 'PATCH_APPLICATION_PRODUCTS') {
          const obj = productsRequestDetails;
          obj.push(requestDetails);
          setProductsRequestDetails(obj);
        } else if (reqType === 'APPLICATION_CERTIFICATES') {
          setRequestDetailsMap({
            ...requestDetailsMap,
            ['certificates']: [
              ...requestDetailsMap['certificates'] || [],
              buildCertificatesData(requestDetails),
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else if (reqType === 'APPLICATION_API_KEYS') {
          const { dataTable } = buildEditRequestTable(classes, requestDetails) || {};
          setRequestDetailsMap({
            ...requestDetailsMap,
            ['apikeys']: [
              ...requestDetailsMap['apikeys'] || [],
              {
                ...requestDetails.request,
                requestEntities: dataTable,
              },
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else if (reqType === 'APPLICATION_OAUTH_CLIENTS') {
          const { dataTable } = buildEditRequestTable(classes, requestDetails) || {};
          setRequestDetailsMap({
            ...requestDetailsMap,
            ['oauthclients']: [
              ...requestDetailsMap['oauthclients'] || [],
              {
                ...requestDetails.request,
                requestEntities: dataTable,
              },
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else {
          const { type, dataTable } = buildEditRequestTable(classes, requestDetails);
          if (requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE') {
            setRequestDetailsMap({
              ...requestDetailsMap,
              [type]: dataTable,
              ['addinfo']: buildDetailsData(classes, requestDetails.original.applicationDetails, null, true),
            });
          } else {
            if (!requestDetailsMap['details'] && !detailsRequestExist) {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
                drydetails:
                  buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
              });
            } else {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
              });
            }
          }
          setRequestInfoMap({
            ...requestInfoMap,
            [type]: requestDetails.request,
          });
        }
      }
    }
  }, [requestDetails]);
  useEffect(() => {
    let requestDetailsObject = {};
    if (listResults && requestDetailsCount === listResults.length && !singleRequest) {
      if (apisRequestDetails.length > 0) {
        const { type, dataTable } = buildEditApisRequestTable(apisRequestDetails, apiPlansEnabled);
        let apisTable = uniqBy(dataTable, 'uuid');
        apisTable = sortBy(apisTable, 'modifyTs').reverse();
        //Added code for app requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE'
        if (!requestDetailsMap['details'] && !detailsRequestExist) {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: apisTable,
            drydetails:
              buildDetailsData(classes, apisRequestDetails[0].applicationExcerpt, null, false),
          };
        } else {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: dataTable,
          };
        }
      }
      if (productsRequestDetails.length > 0) {
        const { type, dataTable } = buildEditProductsRequestTable(productsRequestDetails);
        let productsTable = uniqBy(dataTable, 'uuid');
        productsTable = sortBy(productsTable, 'modifyTs').reverse();
        if (!requestDetailsMap['details'] && !detailsRequestExist) {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: productsTable,
            drydetails:
              buildDetailsData(classes, productsRequestDetails[0].applicationExcerpt, null, false),
          };
        } else {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: productsTable,
          };
        }
      }
      setRequestDetailsMap({
        ...requestDetailsMap,
        ...requestDetailsObject,
      });
    }
  }, [
    requestDetailsCount, listResults, apisRequestDetails, requestDetails, productsRequestDetails,
  ]);
  useEffect(() => {
    if (requestUpdateStatus) {
      setShowActionAlert(false);
      setAlertReason('');
      if (singleRequest) {
        if (requestUpdateStatus === SUCCESS) {
          bumpRequestsNumberVersion();
          const message = intl.getI18nMessage(`label.application.details.section.${actionType}.success`);
          localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
          localStorage.setItem('notificationMessageRequestSaveSuccess', message);
          props.push('/admin/console/requests');
        } else if (requestUpdateStatus === FAIL) {
          let errorMsg = appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.${actionType}.error`));
          if (errors && errors.length > 0 && errors[0].field === 'keyStoreCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
        }
      } else {
        if (requestUpdateStatus === SUCCESS) {
          if (pendingRequestCount === 1) {
            bumpRequestsNumberVersion();
            const message = intl.getI18nMessage(`label.application.details.section.${actionType}.all.success`);
            localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
            localStorage.setItem('notificationMessageRequestSaveSuccess', message);
            props.push('/admin/console/requests');
          } else {
            setPendingRequestCount(pendingRequestCount - 1);
            window.location.reload();
          }
        } else if (requestUpdateStatus === FAIL) {
          let errorMsg = appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.${actionType}.error`));
          if (errors && errors.length > 0 && errors[0].field === 'keyStoreCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
        }
        setActionTableMap({
          ...actionTableMap,
          [actionTable]: {
            status: requestUpdateStatus,
            actionType: actionType,
          },
        });
      }
    }
  }, [requestUpdateStatus]);
  useEffect(() => {
    if (appWithdrawStatus) {
      if (appWithdrawStatus === SUCCESS) {
        if (pendingRequestCount === 1) {
          bumpRequestsNumberVersion();
          const message = intl.getI18nMessage(`label.application.details.section.withdraw.success`);
          notifyMessages(message, ALERT_SUCCESS);
          props.push('/admin/console/requests');
        } else {
          setPendingRequestCount(pendingRequestCount - 1);
          window.location.reload();
        }
      } else if (appWithdrawStatus === FAIL) {
        let errorMsg;
        if (errors && errors.length > 0) {
          errorMsg = errors[0].error;
        }
        errorMsg = errorMsg ? errorMsg : appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.withdraw.error`));
        notifyMessages(errorMsg, ALERT_ERROR);
      }
    }
  }, [appWithdrawStatus]);
  useEffect(() => {
    setShowActionAlert(false);
    if (get(appReviewResponse, 'hasErrors') && appReviewUpdateStatus === SUCCESS) {
      const message = get(appReviewResponse, 'action') === 'ACCEPT'
        ? intl.getI18nMessage(`label.application.details.section.accept.failed`) :
        intl.getI18nMessage(`label.application.details.section.reject.failed`);
      notifyMessages(appendGetMoreInfoLink(message), ALERT_ERROR);
      window.location.reload();
    } else if (appReviewUpdateStatus === SUCCESS) {
      bumpRequestsNumberVersion();
      localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
      localStorage.setItem('notificationMessageRequestSaveSuccess',
        intl.getI18nMessage('label.application.details.section.accept.all.success'));
      props.push('/admin/console/requests');
    } else if (appReviewUpdateStatus === FAIL) {
      notifyMessages(intl.getI18nMessage(`label.application.details.section.${actionType}.all.error`), ALERT_ERROR, true);
      window.location.reload();
    }
  }, [appReviewUpdateStatus]);

  useEffect(() => {
    if (actionType === 'reject') {
      setDisableActionSubmit(false);
      const isAlertReasonEmpty = !alertReason || !alertReason.trim();
      if (requestType.includes('APPLICATION') && isAlertReasonEmpty) {
        setDisableActionSubmit(true);
      }
      if (requestType === 'REGISTRATION' && shouldNotifyUser && isAlertReasonEmpty) {
        setDisableActionSubmit(true);
      }
    }
  }, [shouldNotifyUser, showActionAlert])

  const appendGetMoreInfoLink = (message) => <>{`${message}`} {getMoreInfoLink(onClickGetMoreInfoLink)}</>

  const notifyMessages = (message, status, timeout) => {
    setNotificationStatus(status);
    localStorage.setItem('notificationStatus', status);
    setNotificationMessage(message);
    localStorage.setItem('notificationMessage', message);
    if (timeout) {
      setTimeout(() => {
        notifyMessages('', '');
      }, 3000);
    }
  };
  const reviewEntityRequest = (action) => {
    if (singleRequest) {
      setUuidType('REQUEST');
      setActionUuid(singleRequestUuid);
    } else {
      setUuidType('ENTITY');
      setActionUuid(entityUuid);
    }
    setActionType(action);
    setShowActionAlert(true);
  }
  const review = (uuidType, action, uuid, actionTable, reviewRequestType) => {
    setUuidType(uuidType);
    setActionType(action);
    setActionUuid(uuid);
    setActionTable(actionTable);
    setShowActionAlert(true);
    setReviewRequestType(reviewRequestType);
  };
  const submitReview = () => {
    if (uuidType === 'ENTITY' || reviewRequestType) {
      props.reviewApplication(actionUuid, actionType, alertReason, reviewRequestType);
    } else {
      setReviewRequestType('');
      const payload = {
        isAccept: actionType === 'accept',
        requestId: actionUuid,
        reason: alertReason ? alertReason : '',
      }
      if (requestType === 'REGISTRATION') {
        payload['shouldNotifyUser'] = shouldNotifyUser;
        payload['reason'] = shouldNotifyUser ? alertReason : '';
        if (shouldAssignOrgRole) {
          payload['assignedOrg'] = assignedOrg.uuid;
          payload['assignedRole'] = assignedRole;
        }
        payload['userEmail'] = userEmail;
      }
      props.submitRequest(payload);
    }
  };

  const onWithdraw = (requestUuid) => {
    props.withdrawRequest(requestUuid)
  }

  const onUserEmailChange = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    setUserEmail(email);
    setUserEmailError(!emailRegex.test(email));
  }

  const onAssignedOrgChange = (org = {}) => {
    if (!org) org = { uuid: '', name: '' }
    setAssignedOrg(org);
    setAssignedOrgSearchText(org.name);
  };

  const onAssignedOrgSearchTextChange = (orgSearchText = '') => {
    fetchOrgSuggestions({ name: orgSearchText, status: "ENABLED" });
    setAssignedOrgSearchText(orgSearchText);
  };

  const onClickTableValue = () => {
    setShouldAssignOrgRole(true);
    reviewEntityRequest('accept')
  }

  const onAssignedRoleChange = (role) => setAssignedRole(role);
  const onShouldNotifyUserChange = () => setShouldNotifyUser(shouldNotifyUser => !shouldNotifyUser)
  const onAlertReasonChange = (value) => {
    setAlertReason(value);
    if (actionType === 'reject') {
      value ? setDisableActionSubmit(false) : setDisableActionSubmit(true);
    }
  };
  const getAlertDialogInnerComponent = () => {
    return <AlertDialogInnerComponent
      classes={classes}
      requestType={requestType.includes('APPLICATION') ? 'APPLICATION' : 'REGISTRATION'}
      isAcceptAction={actionType === 'accept'}
      userEmail={userEmail}
      userEmailError={userEmailError}
      onUserEmailChange={onUserEmailChange}
      getI18nMessage={getI18nMessage}
      shouldAssignOrgRole={shouldAssignOrgRole}
      setShouldAssignOrgRole={setShouldAssignOrgRole}
      orgSuggestions={orgSuggestions}
      assignedOrgSearchText={assignedOrgSearchText}
      onAssignedOrgSearchTextChange={onAssignedOrgSearchTextChange}
      assignedOrg={assignedOrg}
      onAssignedOrgChange={onAssignedOrgChange}
      assignedRole={assignedRole}
      onAssignedRoleChange={onAssignedRoleChange}
      assignRoleOptions={assignRoleOptions}
      shouldNotifyUser={shouldNotifyUser}
      onShouldNotifyUserChange={onShouldNotifyUserChange}
      alertReason={alertReason}
      onAlertReasonChange={onAlertReasonChange}
    />
  }

  const getAlertDialogInnerComponentMoreInfo = () => {
    return <HelpContainer
      helpItems={APPLICATION_REQUEST_FAILED_MORE_INFO.details}
      containerClass={classes.helpContainerClass}
    />
  }

  const onClickGetMoreInfoLink = () => {
    setShowActionAlertMoreInfo(true)
    notifyMessages('', '');
  }

  const getMoreInfoLink = (onClickHandler) =>
    <Link variant="inherit" onClick={onClickHandler}>
      {intl.getI18nMessage('label.application.details.section.failed.more.info')}
    </Link>

  const onAlertDialogClose = () => {
    setShouldAssignOrgRole(false);
    setShouldNotifyUser(false);
    setShowActionAlert(false);
  }

  const colCallback = (data) => {
    setShowOAuthClientDetails(JSON.stringify(JSON.parse(data), null, 2));
  }
  const closeOAuthClientDetails = () => {
    setShowOAuthClientDetails(null);
  }

  const getOAuthDialogContent = (value) => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <FormTextField
            id='auth-provider-client-defn-metadata-field'
            value={value}
            rows={30}
            multiline={true}
            onChange={() => { }}
            disabled
            fieldContainerClass={classes.textFieldContainer}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <div className={classes.content}
        id="request-details-page" data-apim-test="request-details-page"
      >
      <LoadingDialog
        className={classes.genericLoadingDialog}
        isOpen={operationLoading}
        title={intl.getI18nMessage('label.api.key.generic.loading.title')}
        description={intl.getI18nMessage('label.api.key.generic.loading.text')}
        dialogId="generic-loading-dialog"
      />
        {showOAuthClientDetails &&
          <AlertDialog
            id="request-oauth-client-details-dialog"
            data-apim-test="request-oauth-client-details-dialog"
            isOpen={showOAuthClientDetails}
            onClose={closeOAuthClientDetails}
            onCancel={closeOAuthClientDetails}
            showCloseButton={true}
            showSubmit={false}
            showCancel={true}
            cancelText={intl.getI18nMessage('label.close.button')}
            title={intl.getI18nMessage('label.auth.providers.details.sample.client.definition.metadata')}
            component={getOAuthDialogContent(showOAuthClientDetails)}
          />
        }
        {notificationMessage &&
          <AlertMessages
            id="app-details-notification"
            hasNotificationIcon={true}
            hasAction={true}
            variant={notificationStatus}
            message={notificationMessage}
            containerClass={classes.alertMessages}
            actionButtonClass={classes.alertMessagesCloseButton}
            onClose={() => { notifyMessages('', ''); }}
          />
        }
        <AlertDialog
          id="request-detail-error-more-info-dialog"
          data-apim-test="request-detail-error-more-info-dialog"
          isOpen={showActionAlertMoreInfo}
          showDefault={true}
          showSubmit={false}
          showCancel={false}
          defaultText={intl.getI18nMessage('label.close.button')}
          title={intl.getI18nMessage('label.application.details.section.failed.more.info.dialog.title')}
          component={getAlertDialogInnerComponentMoreInfo()}
          onDefault={() => setShowActionAlertMoreInfo(false)}
        />
        <AlertDialog
          id="request-detail-accept-reject-dialog"
          data-apim-test="request-detail-accept-reject-dialog"
          isOpen={showActionAlert}
          title={intl.getI18nMessage(`label.request.list.actions.alert.${actionType}.title`)}
          description={intl.getI18nMessage('label.request.list.actions.alert.description')}
          disableSubmit={actionType === 'reject' ? disableActionSubmit : false}
          submitText={intl.getI18nMessage(`label.request.list.actions.${actionType}`)}
          cancelText={intl.getI18nMessage('label.cancel.button')}
          component={showActionAlert && getAlertDialogInnerComponent()}
          onClose={onAlertDialogClose}
          onSubmit={() => submitReview()}
          onCancel={onAlertDialogClose}
          submitButtonClass={actionType === 'accept' ? '' : classes.rejectSubmitButton}
        />
        <div className={classes.header}>
          <div className={classes.sectionHead}>
            {(requestType === 'APPLICATION' || requestType === 'REGISTRATION') ?
              <Typography variant="h1" className={classes.pageTitle}>
                {entityName}
              </Typography> :
              <Link underline='none' variant="h1" href={`/admin/console/applications/details/${entityUuid}`} className={classes.pageTitle}>
                {entityName}
              </Link>
            }
            <>
              {((isOrgPublisherRole || isApiOwnerRole) && get(requestDetails, 'updateRequest') &&
                keys(get(requestDetails, 'updateRequest')) &&
                keys(get(requestDetails, 'updateRequest')).length === 1 &&
                get(requestDetails, 'updateRequest.applicationProducts') &&
                get(requestDetails, 'updateRequest.applicationProducts').length === 1) ?
                <div />
                :
                <>
                  {((singleRequest || pendingRequestCount > 0) ||
                    ((get(requestDetails, 'request.requestSubtype') === 'CREATE') &&
                      get(requestDetails, 'request.requestType') === 'APPLICATION') && (isOrgPublisherRole || isPublisherRole)) &&
                    <div className={classes.pageButtonDiv}>
                      <Button
                        id="accept-button"
                        data-apim-test="accept-button"
                        variant="contained"
                        color="secondary"
                        className={classes.acceptButton}
                        onClick={() => reviewEntityRequest('accept')}
                      >
                        {intl.getI18nMessage(`label.application.details.section.accept.${singleRequest ? '' : 'all.'}button`)}
                      </Button>
                      <Button
                        id="reject-button"
                        data-apim-test="reject-button"
                        className={classes.rejectButton}
                        onClick={() => reviewEntityRequest('reject')}
                      >
                        {intl.getI18nMessage(`label.application.details.section.reject.${singleRequest ? '' : 'all.'}button`)}
                      </Button>
                    </div>
                  }
                </>
              }
            </>
          </div>
          <Typography variant="body1">
            {getSubTitleContent(requestDate, requestType, requestor)}
          </Typography>
          <Typography variant="h3">
            {getRequestTypeHeading(requestType)}
          </Typography>
          {!singleRequest || requestType === 'APPLICATION_UPDATE' &&
            <FormControlLabel
              control={
                <Checkbox
                  value={showChangesOnly}
                  onChange={(e) => setShowChangesOnly(e.target.checked)}
                />
              }
              label={intl.getI18nMessage("label.request.details.show.changed.values.checkbox")}
            />
          }
        </div>
        {orderList.filter(type => Object.keys(requestDetailsMap).includes(type)).map(key => {
          if (includes(['apikeys', 'apiplans', 'apis', 'products', 'certificates', 'oauthclients'], key) && requestDetailsMap[key].length > 0 &&
            (get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_APIS'
              || get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_API_PLANS'
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_CERTIFICATES'
              || get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_PRODUCTS'
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_API_KEYS')
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_OAUTH_CLIENTS') {
            return (
              <MultiRequestTable
                key={key}
                sectionType={key}
                columns={getMultiRequestTableColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE',
                  key, hasPublisherRole(props.user), requestType, colCallback)}
                rows={requestDetailsMap[key]}
                onReview={review}
                classes={classes}
                user={props.user}
                entityUuid={entityUuid}
                isAdmin={isAdmin}
                isPublisherRole={isPublisherRole}
                isOrgPublisherRole={isOrgPublisherRole}
                onWithdraw={onWithdraw}
                hasRowHeader={['apikeys', 'apis', 'apiplans', 'products', 'oauthclients'].includes(key)}
              />
            )
          } else {
            return (
              <RequestSectionTable
                key={key}
                sectionType={key}
                columns={getTableColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE',
                  key, onClickTableValue, hasPublisherRole(props.user), requestType, colCallback)}
                rows={showChangesOnly && key !== "drydetails"
                  ? requestDetailsMap[key].filter(row => row.selected)
                  : requestDetailsMap[key]}
                requestInfo={requestInfoMap[key]}
                actionStatus={actionTableMap[key]}
                onReview={review}
                classes={classes}
                isAdmin={isAdmin}
                isPublisherRole={isPublisherRole}
                isOrgPublisherRole={isOrgPublisherRole}
                onWithdraw={onWithdraw}
                user={props.user}
              />
            )
          }
        })}
        <Footer />
      </div>
    </Fragment>
  );
};

export const AlertDialogInnerComponent = (props) => {
  const {
    classes,
    requestType,
    isAcceptAction,
    userEmail,
    userEmailError,
    onUserEmailChange,
    getI18nMessage,
    shouldAssignOrgRole,
    setShouldAssignOrgRole,
    orgSuggestions,
    assignedOrgSearchText,
    onAssignedOrgSearchTextChange,
    assignedOrg,
    onAssignedOrgChange,
    assignedRole,
    onAssignedRoleChange,
    assignRoleOptions,
    shouldNotifyUser,
    onShouldNotifyUserChange,
    alertReason,
    onAlertReasonChange,
    isBulkRequest = false,
  } = props;
  return (
    <div>
      {
        (requestType === "REGISTRATION" && isAcceptAction) &&
        <>
          {
            !isBulkRequest &&
            <FormTextField
              fieldContainerClass={classes.fieldContainerClass}
              id={"assign-email-text-field"}
              name={"Email"}
              value={userEmail}
              error={userEmailError}
              helperText={getI18nMessage("label.request.list.actions.alert.assign.email.helper.text")}
              handleChange={(e) => onUserEmailChange(e)}
            />
          }
          <div className={classes.checkBoxContainer}>
            <Checkbox
              id="requests-user-assign-org-role-checkbox"
              size="small"
              edge="start"
              disableRipple
              inputProps={{ 'aria-label': 'primary checkbox' }}
              onClick={() => setShouldAssignOrgRole(shouldAssignOrgRole => !shouldAssignOrgRole)}
              checked={shouldAssignOrgRole}
            />
            <Typography variant={"body1"}>
              {getI18nMessage("label.request.list.actions.alert.assign.org.role.checkbox")}
            </Typography>
          </div>
          {
            (shouldAssignOrgRole && isAcceptAction) &&
            <div className={classes.assignOrgRole}>
              <FormAutoCompleteCombo
                id="request-filter-by-org"
                fieldContainerClass={classes.fieldContainerClass}
                filterSelectedOptions={false}
                name={getI18nMessage('label.request.list.actions.alert.assign.org')}
                helperText={getI18nMessage('label.request.list.actions.alert.assign.org.helper.text')}
                inputLabel={getI18nMessage('label.organization.name')}
                onInputChange={(e, value) => onAssignedOrgSearchTextChange(value)}
                onChange={(e, value) => onAssignedOrgChange(value)}
                options={orgSuggestions}
                searchText={assignedOrgSearchText}
                value={assignedOrg}
              />
              <FormSelect
                id="user-filter-by-role"
                data-apim-test="user-filter-by-role"
                name={getI18nMessage('label.request.list.actions.alert.assign.role')}
                fieldContainerClass={classes.fieldContainerClass}
                data={assignRoleOptions}
                noNativeSelect
                noNoneOption
                value={assignedRole}
                displayEmpty={true}
                disabled={!assignedOrgSearchText}
                handleChange={(role) => onAssignedRoleChange(role)}
                helperText={getI18nMessage('label.request.list.actions.alert.assign.role.helper.text')}
              />
            </div>
          }
        </>
      }
      {requestType === 'REGISTRATION' &&
        <div className={classes.checkBoxContainer}>
          <Checkbox
            id="requests-notify-user-checkbox"
            size="small"
            edge="start"
            disableRipple
            inputProps={{ 'aria-label': 'primary checkbox' }}
            onClick={() => onShouldNotifyUserChange()}
            checked={shouldNotifyUser}
          />
          <Typography variant={"body1"}>
            {isAcceptAction ? getI18nMessage("label.request.notify.user.checkbox.acceptance")
              : getI18nMessage("label.request.notify.user.checkbox.rejection")}
          </Typography>
        </div>
      }
      {
        (requestType === 'APPLICATION' || requestType === 'REGISTRATION' && shouldNotifyUser) &&
        <>
          <FormTextField
            fieldContainerClass={classes.alertMessageContainerClass}
            maxLength={1000}
            multiline
            handleChange={(value) => onAlertReasonChange(value)}
            placeholder={getI18nMessage(`label.request.list.actions.alert.${isAcceptAction ? 'accept' : 'reject'}.placeholder`)}
            rows={4}
            textFieldClass={classes.alertMessageClass}
            value={alertReason}
          />
          <div className={classes.alertMessageMaxLengthWarningClass}>
            {getI18nMessage('label.request.list.actions.alert.max.length.warning')}
          </div>
        </>
      }
    </div>
  );
};

AlertDialogInnerComponent.propTypes = {
  classes: object,
  requestType: string,
  isAcceptAction: bool,
  userEmail: object,
  userEmailError: bool,
  onUserEmailChange: func,
  getI18nMessage: func,
  shouldAssignOrgRole: bool,
  setShouldAssignOrgRole: func,
  orgSuggestions: arrayOf(shape({})),
  assignedOrgSearchText: string,
  onAssignedOrgSearchTextChange: func,
  assignedOrg: arrayOf(shape({})),
  onAssignedOrgChange: func,
  assignedRole: object,
  onAssignedRoleChange: func,
  assignRoleOptions: array,
  shouldNotifyUser: bool,
  onShouldNotifyUserChange: func,
  alertReason: string,
  onAlertReasonChange: func,
  isBulkRequest: bool,
}

const mapStateToProps = state => ({
  listResults: getDetailsListResults(state),
  requestDetails: getRequestDetails(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  appReviewUpdateStatus: getAppReviewUpdateStatus(state),
  orgSuggestions: getOrgSuggestions(state),
  user: getUserDetails(state),
  errors: getErrors(state),
  apiPlansEnabled: getFeatureFlagApiPlans(state),
  appReviewResponse: getAppReviewResponse(state),
  appWithdrawStatus: getAppWithdrawStatus(state),
  operationLoading: getOperationLoading(state),
});

const mapDispatchToProps = {
  fetchListDetails,
  fetchRequestDetails,
  fetchOrgSuggestions,
  submitRequest,
  reviewApplication,
  withdrawRequest,
  push,
};

ApplicationRequestDetails.propTypes = {
  fetchListDetails: func,
  requestDetails: object,
  fetchRequestDetails: func,
  fetchOrgSuggestions: func,
  listResults: arrayOf(object),
  getListResults: func,
  orgSuggestions: arrayOf(shape({})),
  classes: object,
  requestUpdateStatus: string,
  appReviewUpdateStatus: string,
  submitRequest: func,
  reviewApplication: func,
  push: func,
  user: object,
  errors: arrayOf(object),
  apiPlansEnabled: bool,
  appReviewResponse: object,
  withdrawRequest: func,
  appWithdrawStatus: string,
  operationLoading: bool,
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ApplicationRequestDetails);
